import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ProductCollection} from 'types/product-collection';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getPricingProductCollection = api.injectEndpoints({
  endpoints: builder => ({
    getPricingProductCollection: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `prices/product-collections`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<{product_collections: ProductCollection[]}>;

export const {useGetPricingProductCollectionQuery} =
  getPricingProductCollection;
